export default (params) => ({
  trigger: {
    name: 'configurator.remove_item_from_bundle',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'configurator',
          'configurator_overlay',
        ],
      },
    },
    event: {
      name: 'remove_item',
      params: {
        list: 'configurator',
      },
    },
  },
});
